<template>
  <Modal :title="`ぐるなびネット予約クーポンが\n設定された予約`" @close="onClose" hideCloseButton>
    <template #content>
      <div class="inner" v-if="isOverEndTime || syncType === 12">
        <p>利用条件に満たない変更の場合、<br />クーポンが使用できなくなる可能性があります。</p>
        <BrowserOpen url="https://pro.gnavi.co.jp" class="link">
          <span>PROfor飲食店</span> <externalIcon class="icon"
        /></BrowserOpen>
        でご利用条件を確認してください。
        <p v-if="isOverEndTime" class="note">利用対象にしない場合はクーポンを取消してください。</p>
      </div>
      <div class="inner" v-else>
        利用条件に満たない変更の場合、<br />クーポンが使用できなくなる可能性があります。<br />確定しますか？
      </div>
    </template>
    <template #footer-center>
      <Button class="button" @click="onClose">戻る</Button>
      <Button class="button" primary @click="confirm">確定</Button>
    </template>
  </Modal>
</template>

<script>
import externalIcon from '@/components/icons/external'
import BrowserOpen from '@/components/atoms/BrowserOpen'
import Button from '@/components/atoms/Button'
import Modal from '@/components/molecules/Modal'

export default {
  name: 'CouponWarningModal',
  components: {
    externalIcon,
    BrowserOpen,
    Button,
    Modal,
  },
  props: {
    isOverEndTime: { type: Boolean, default: false },
    syncType: { type: Number },
  },
  methods: {
    confirm() {
      this.$emit('onConfirm')
    },
    onClose() {
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="postcss" scoped>
.inner {
  line-height: 24px;
  margin-top: 32px;
  padding: 0 40px;
  text-align: center;
  .responsive & {
    @media screen and (--sp-modal) {
      margin-top: 28px;
      padding: 0 16px;
      br {
        display: none;
      }
    }
  }
}

.link {
  display: inline;
  padding-right: 16px;
  position: relative;
  text-decoration: underline;
  .icon {
    fill: var(--brand-color);
    height: 16px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
  }
}

.note {
  margin-top: 16px;
  .responsive & {
    @media screen and (--sp-modal) {
      margin-top: 20px;
    }
  }
}

.button {
  margin-top: 32px;
}
</style>
